// extracted by mini-css-extract-plugin
export default {"box_main":"box_box_main__LFE1K"};